import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    lastQuery: null,
    productList: [],
    totalRecords: 0,
};

const mutations = {
    setProductList(state, data) {
        state.productList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setTotalRecords(state, total) {
        state.totalRecords = total;
    },
};

const getters = {
    products(state) {
        return state.productList;
    },
    productList: state => state.productList,
    totalRecords: state => state.totalRecords,
};

const actions = {
    findProducts({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    relation: 1,
                },
                params,
            ),
        };

        let products = state.productList.filter(p => {
            return params.ids.includes(p.id);
        });

        if (products.length === params.ids.length) {
            return Promise.resolve(products);
        }

        startLoading(dispatch, 'find-products');

        return axios
            .get(Laroute.route('franchise.vue.products'), options)
            .then(res => {
                endLoading(dispatch, 'find-products');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-products');
                throw err;
            });
    },

    getProduct({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.inventory.item.show', { id: id });
        startLoading(dispatch, 'fetch-product');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-product');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-product');
                throw err;
            });
    },

    async fetchProducts(context, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    relation: 1,
                },
                params,
            ),
        };

        const url = Laroute.route('franchise.vue.products');

        try {
            const { data } = await axios.get(url, options);
            return data;
        } catch (e) {
            throw e;
        }
    },

    getProductList({ commit, dispatch }, params = {}) {
        startLoading(dispatch, 'fetch-product');

        dispatch('fetchProducts', params)
            .then(res => {
                let { data, count } = res;

                commit('setProductList', data);
                commit('setTotalRecords', count);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-product');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-product');
                throw err;
            });
    },

    getProductListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.productList.length || state.lastQuery !== params.query) {
            dispatch('getProductList', params);
        }
    },

    updateProduct({ commit, dispatch }, product) {
        let route = Laroute.route('franchise.inventory.item.update', {
            id: product.id,
        });
        startLoading(dispatch, 'save-product');

        return axios
            .patch(route, product)
            .then(res => {
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-product');
                throw err;
            });
    },

    bulkUpdateProducts({ commit, dispatch }, update) {
        startLoading(dispatch, 'save-product');

        return axios
            .patch(Laroute.route('franchise.inventory.item.bulkUpdate'), update)
            .then(res => {
                endLoading(dispatch, 'save-product');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-product');
                throw err;
            });
    },

    createProduct({ commit, dispatch }, product) {
        let route = Laroute.route('franchise.inventory.item.store');
        startLoading(dispatch, 'save-product');

        return axios
            .post(route, product)
            .then(res => {
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-product');
                throw err;
            });
    },

    bulkRestoreProduct({ commit, dispatch }, update) {
        startLoading(dispatch, 'save-product');

        return axios
            .patch(Laroute.route('franchise.inventory.item.restore'), update)
            .then(res => {
                endLoading(dispatch, 'save-product');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-product');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/product.js